import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useDispatch } from "react-redux";
import { CHANGE_SHOW_SAFEWORD } from "../../actions/types";

const SafewordDisplay = ({ safeword, showSafeword }) => {
  const dispatch = useDispatch();
  const onClickInSafeword = () => {
    dispatch({ type: CHANGE_SHOW_SAFEWORD });
  };

  if (!safeword) return <></>;
  return (
    <b
      style={{
        position: "absolute",
        cursor: "pointer",
        top: 8,
      }}
      onClick={onClickInSafeword}
    >
      {showSafeword ? safeword : "******"}
    </b>
  );
};

SafewordDisplay.propTypes = {
  safeword: PropTypes.string,
  showSafeword: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  showSafeword: state.safeword.showSafeword,
});

export default connect(mapStateToProps)(SafewordDisplay);
